/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Insert_FieldInputs */

const cs_builder_insert_field = /** @type {(inputs: Builder_Insert_FieldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vložit pole`)
};

const en_builder_insert_field = /** @type {(inputs: Builder_Insert_FieldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insert field`)
};

/**
* | output |
* | --- |
* | "Insert field" |
*
* @param {Builder_Insert_FieldInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_insert_field = /** @type {((inputs?: Builder_Insert_FieldInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Insert_FieldInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_insert_field(inputs)
	return cs_builder_insert_field(inputs)
});